// section: minicart
class MiniCart extends HTMLElement {
  constructor() {
    super();

    var self = this;

    this.renderCart();

    this.sectionId = 'shopify-section-' + this.querySelector('.minicart-container').dataset.sectionId;

    document.addEventListener('shopify:section:load', function(e) {
      if(self.sectionId == e.target.id) {
        self.renderCart(), self.show();
      }
    });

    document.addEventListener('shopify:section:select', function(e) {
      if(self.sectionId == e.target.id)
        self.renderCart(), self.show();
    });

    document.addEventListener('shopify:block:select', function(e) {
      if(document.querySelector('#' + self.sectionId + ' #block--' + e.target.id))
        self.renderCart(), self.show();
    });

    window.on('resize', theme.utils.debounce(300, function() {
      if(document.documentElement.clientWidth > 500){
        self.renderCart();
      }
    }));

    document.addEventListener('click', (e) => {
      if(self.details.hasAttribute('open') && (!e.target.closest('details.minicart') || e.target.classList.contains('menu-drawer--content')))
        self.hide();
    });
  }

  bindEvents(){
    var self = this;
    this.details = this.closest('details');

    if(this.querySelector('.modal__close')) {
      this.querySelector('.modal__close').addEventListener('click', function(){
        if(this.closest('details[open]')){
          this.closest('details[open]').removeAttribute('open'),
          this.scrollY = document.body.style.top,
          document.body.style.top = '',
          document.body.classList.remove('overflow-hidden-fixed'),
          window.scrollTo({left: 0, top: parseInt(this.scrollY || '0') * -1, behavior: "instant"});
        } else {
          return;
        }
      });
    }
    
    this.details.addEventListener("toggle", function(e) {
      e.preventDefault();

      if(!self.details.classList.contains('disclosure-has-popup')) {
        self.details.hasAttribute("open") ?
          (
            document.body.style.top = `-${window.pageYOffset}px`,
            document.body.classList.add('overflow-hidden-fixed')
          ) :
          ( 
            this.scrollY = document.body.style.top,
            document.body.style.top = '',
            document.body.classList.remove('overflow-hidden-fixed'),
            window.scrollTo({left: 0, top: parseInt(this.scrollY || '0') * -1, behavior: "instant"})
          );
      }
    });
  }

  show(){
    this.details.setAttribute('open', '');
    if(this.details.classList.contains('disclosure-has-popup')) {
      document.body.style.top = `-${window.pageYOffset}px`,
      document.body.classList.add('overflow-hidden-fixed'),
      this.details.classList.add('menu-opening')
    }
  }

  open(){
    if((Shopify.theme_settings.atc_action == "once" && !sessionStorage.getItem('miniCartOpen')) || Shopify.theme_settings.atc_action == "always") {
      this.details.setAttribute('open', '');

      if(this.details.classList.contains('disclosure-has-popup'))
        document.body.style.top = `-${window.pageYOffset}px`,
        document.body.classList.add('overflow-hidden-fixed'),
        this.details.classList.add('menu-opening')
      if(Shopify.theme_settings.atc_action == "once" && !sessionStorage.getItem('miniCartOpen'))
        sessionStorage.setItem('miniCartOpen', true);
    }
  }

  hide(){
    this.details.removeAttribute('open');
    if(this.details.classList.contains('disclosure-has-popup')) this.details.classList.remove('menu-opening')
  }

  renderCart(){
    if(this.querySelector('.minicart-content .minicart-container'))
      this.querySelector('.minicart-content .minicart-container').remove();

    if(document.querySelector('.minicart-section')){
      this.querySelector('.minicart-content').innerHTML += document.querySelector('.minicart-section').cloneNode(true).innerHTML;
      new theme.Cart(this.querySelector(".minicart-container"))
    }
    this.bindEvents();
  }
}
customElements.define('mini-cart', MiniCart);